/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnvironmentVariablesResponse } from '../models/EnvironmentVariablesResponse';
import type { PublicSystemConfigurationResponse } from '../models/PublicSystemConfigurationResponse';
import type { SystemConfigurationResponse } from '../models/SystemConfigurationResponse';
import type { UpdateSystemConfigurationCommand } from '../models/UpdateSystemConfigurationCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PublicSystemConfigurationService {
    /**
     * Get public system configuration
     * @returns PublicSystemConfigurationResponse
     * @throws ApiError
     */
    public static publicSystemConfigurationControllerGetPublicSystemConfiguration(): CancelablePromise<PublicSystemConfigurationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/public/system-configurations/public',
        });
    }
    /**
     * Get system configuration
     * @returns SystemConfigurationResponse
     * @throws ApiError
     */
    public static publicSystemConfigurationControllerGetSystemConfiguration(): CancelablePromise<SystemConfigurationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/public/system-configurations',
            errors: {
                401: `User wasn't authenticated.`,
                403: `User didn't have permissions to perform this action.`,
                500: `Something went wrong.`,
            },
        });
    }
    /**
     * Update system configuration
     * @returns SystemConfigurationResponse
     * @throws ApiError
     */
    public static publicSystemConfigurationControllerUpdateSystemConfiguration({
        requestBody,
    }: {
        /**
         * UpdateSystemConfigurationCommand
         */
        requestBody?: UpdateSystemConfigurationCommand,
    }): CancelablePromise<SystemConfigurationResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/public/system-configurations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `User wasn't authenticated.`,
                403: `User didn't have permissions to perform this action.`,
                500: `Something went wrong.`,
            },
        });
    }
    /**
     * System environment variables
     * @returns EnvironmentVariablesResponse
     * @throws ApiError
     */
    public static publicSystemConfigurationControllerGetEnvironmentVariables(): CancelablePromise<EnvironmentVariablesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/public/system-configurations/env',
            errors: {
                401: `User wasn't authenticated.`,
                403: `User didn't have permissions to perform this action.`,
                500: `Something went wrong.`,
            },
        });
    }
}
